import { TeGueltigkeit } from '../../mdqx-graphql-types';

export class TEGueltigkeitEntity {
    public static readonly GqlFields = 'id name';

    public Id: number;
    public Name: string;

    constructor(teGueltigkeitType?: TeGueltigkeit | null) {
        if (teGueltigkeitType && teGueltigkeitType.id != null && teGueltigkeitType.name != null) {
            this.Id = teGueltigkeitType.id;
            this.Name = teGueltigkeitType.name;
        } else {
            console.error('received broken TeGueltigkeitType', teGueltigkeitType);
            throw Error();
        }
    }
}
